import React from "react";
import styled from "styled-components";
import logo from "./assets/logo.svg";
import logo_header from "./assets/logo_header.svg";
import logo_full from "./assets/logo-full.svg";
import * as mixpanel from "core/integrations/mixpanel";

const Wrap = styled.div`
  max-height: 70px;
  align-items: center;
  margin-bottom: 10px;
  background-color: #fff;
  border-color: #f76367;
  border-style: solid;
  border-width: 10px 0px 0px 0px;
`;

const Title = styled.div`
  font-family: CircularStd-Black, sans-serif;
  font-size: 28px;
`;

export default ({ right, insiders }) => (
  <Wrap>
    <div className="flex justify-between flex-row ph6-ns pv3-ns pa3-m pa3 items-center">
      <div className="flex center-items">
        <a
          className="pa2 pointer dn-ns"
          href={insiders ? "https://thelobby.io" : "https://beta.thelobby.io"}
          onClick={() => mixpanel.trackEvent("The Lobby logo clicked")}
        >
          <img src={logo} alt="logo" />
        </a>
        <a
          className="pa2 pointer"
          href={insiders ? "https://thelobby.io" : "https://beta.thelobby.io"}
          onClick={() => mixpanel.trackEvent("The Lobby logo clicked")}
        >
          <img src={logo_full} className="" alt="logo_header" />
        </a>
      </div>
      <div className="dn db-ns">
        <img src={logo_header} alt="logo_header" />
      </div>
      {right}
    </div>
  </Wrap>
);



// WEBPACK FOOTER //
// ./src/components/generic/layout/Overlay/Header.js